import * as React from "react"
import { Button } from "./forms.ts"
import { Icon } from "./index.ts"

export const CopyToClipboardButton = ({
  textToCopy,
  text,
  onCopy,
  ...props
}: CopyToClipboardButton.Props) => {
  const { isCopied, copyToClipboard } = useCopyToClipboard(textToCopy, onCopy)

  return (
    <Button onClick={copyToClipboard} type="button" {...props}>
      {isCopied ? <Icon.Check /> : <Icon.Copy />}
      {text && <span>{isCopied ? text.copied : text.idle}</span>}
    </Button>
  )
}

const useCopyToClipboard = (textToCopy: string, onCopy?: () => void) => {
  const [isCopied, setIsCopied] = React.useState(false)

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy)
      setIsCopied(true)
      onCopy?.()
      setTimeout(() => setIsCopied(false), 2000)
    } catch (e) {
      console.error(e)
    }
  }

  return { isCopied, copyToClipboard }
}

export namespace CopyToClipboardButton {
  export type Props = {
    textToCopy: string
    text?: {
      idle: string
      copied: string
    }
    onCopy?: () => void
  } & Omit<Button.Props, "type" | "children">
}
